module.exports = __webpack_public_path__ + "img/hr.f4e06f4.svg";